<template>
  <div class="flex flex-wrap min-h-screen">
    <div
      class="flex flex-col w-full items-start pt-4 border-t border-gray-200 gap-4 px-6"
    >
      <div
        v-if="loading"
        class="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50"
      >
        <div
          class="animate-spin rounded-full h-32 w-32 border-t-4 border-b-4 border-primary-purple"
        ></div>
      </div>
      <div class="flex flex-wrap w-full">
        <AdvancedProgramSettings
          v-if="showAdvancedSettings && !loading"
          :programId="userStore.selectedProgram?.id || ''"
          :initialPayoutOnlyCallDurationMoreThan5="
            payoutOnlyCallDurationMoreThan5
          "
          :initialExpertTags="initialExpertTags"
          @programUpdated="refetchProgramDetails"
        />
      </div>
      <div class="flex flex-col">
        <ComingSoonFeatures />
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import AdvancedProgramSettings from "./AdvancedProgramSettings.vue";
import { useUserStore } from "@/stores/user";
import { gql } from "@apollo/client/core";
import { useQuery } from "@vue/apollo-composable";
import ComingSoonFeatures from "./ComingSoonFeatures.vue";

const GET_PROGRAM_DETAILS = gql`
  query getProgramDetail($programId: ID!) {
    getProgramDetail(programId: $programId) {
      id
      payoutOnlyCallDurationMoreThan5
      expertTags
    }
  }
`;

export default defineComponent({
  name: "AdvancedSettingsContainer",
  components: {
    AdvancedProgramSettings,
    ComingSoonFeatures,
  },
  props: {
    showAdvancedSettings: {
      type: Boolean,
      required: true,
    },
  },
  setup() {
    const userStore = useUserStore();
    const payoutOnlyCallDurationMoreThan5 = ref(false);
    const initialExpertTags = ref<string[]>([]);

    const {
      refetch: refetchProgramDetails,
      onResult,
      onError,
      loading,
    } = useQuery(
      GET_PROGRAM_DETAILS,
      { programId: userStore.selectedProgram?.id },
      { fetchPolicy: "network-only" }
    );

    onResult(
      (result: {
        data?: {
          getProgramDetail?: {
            payoutOnlyCallDurationMoreThan5: boolean;
            expertTags: string[];
          };
        };
      }) => {
        if (result.data?.getProgramDetail) {
          payoutOnlyCallDurationMoreThan5.value =
            result.data.getProgramDetail.payoutOnlyCallDurationMoreThan5;
          initialExpertTags.value = result.data.getProgramDetail.expertTags;
        }
      }
    );

    onError(() => {
      payoutOnlyCallDurationMoreThan5.value = false;
    });

    return {
      userStore,
      payoutOnlyCallDurationMoreThan5,
      initialExpertTags,
      refetchProgramDetails,
      loading,
    };
  },
});
</script>
